import { kybService, useToast, CheckCircleOutline } from '@aslanpay/portal-common-lib';
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { KybApproveModalProps } from './types';

function KybApproveModal({ isOpen, onClose, kybId }: KybApproveModalProps) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    onClose();
  };

  const handleApprove = async () => {
    setIsLoading(true);
    try {
      await kybService.approveKyb(kybId);
      await queryClient.invalidateQueries(['fetchKybsPage']);
      toast({
        position: 'top-right',
        title: 'Business approved',
        status: 'success',
        description: 'This business was approved and the client can now start gifting.',
      });
      onClose();
    } catch (error) {
      toast({
        position: 'top-right',
        title: 'Failed to approve business',
        status: 'error',
        description: 'An error occurred while approving this business. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      onClose={handleClose}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <Text as="h6">Approve business?</Text>
          </HStack>
        </ModalHeader>
        <ModalBody>
          <Text>Please confirm if you want to approve this business.</Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" onClick={handleClose} size="sm">
            Cancel
          </Button>
          <Button
            onClick={handleApprove}
            size="sm"
            isLoading={isLoading}
            leftIcon={<CheckCircleOutline boxSize="20px" />}
          >
            Yes, approve
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default KybApproveModal;
